<template>
  <div class="wrap">
    <div class="wrapTitle">大会亮点</div>
    <div class="wrapEn">HIGHLIGHTS</div>
    <van-swipe :autoplay="3000" @change="onChange" class="swipe">
      <van-swipe-item v-for="(item, index) in arr" :key="index">
        <!-- <img :src="item.Img" alt="" class="swipeImg" /> -->
        <div class="swipeTitle">{{ item.title }}</div>
        <div class="swipeInfo">{{ item.info }}</div>
      </van-swipe-item>
    </van-swipe>
    <img :src="imgSrc" alt="" class="wrapImg" />
    <!-- <div class="banner">
      <van-swipe class="bannerSwipe" :autoplay="3000" @change="onChange">

          <van-swipe-item v-for="(item, index) in bannerArr" :key="index">
            <img :src="item.photo" alt="" class="bannerImg" @click="jumpLink(item.url)" />
          </van-swipe-item>

      </van-swipe>
    </div> -->
  </div>
</template>

<script setup>
import { ref } from 'vue'
const props = defineProps(['arr'])

const arr = props.arr || []

const bannerArr = ref([
  {
    photo: 'https://p3.ssl.qhimg.com/t110b9a930163e676ef9fa9da20.png',
    url: 'https://damddos.com/',
  },
  {
    photo: 'https://p3.ssl.qhimg.com/t110b9a93012f9990adfa9b78ad.png',
    url: 'https://www.uniontech.com/',
  },
  {
    photo: 'https://p1.ssl.qhimg.com/t110b9a93013e2b9495bedf4487.png',
    url:'https://item.jd.com/10020916050888.html',
  }
])

let imgSrc = ref(arr[0].Img)
const onChange = (current) => {
  imgSrc.value = arr[current].Img
}
const jumpLink = (url) => {
  if (url) {
    window.open(url, '_blank')
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  opacity: 1;
  background: #f3f3f3;
  padding: 32px 16px 40px;
  &Title {
    font-family: Source Han Sans;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    font-family: Source Han Sans;
    font-size: 12px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    margin: 2px 0 20px;
  }
  &Img {
    width: 343px;
    position: absolute;
    top: 98px;
    right: 0;
  }
}
:deep(.van-swipe__indicators) {
  position: relative;
  margin-top: 20px;
  justify-content: center;
}
.van-swipe-item {
  display: flex;
  flex-direction: column;
  .swipe {
    // &Img {
    //   width: 343px;
    //   position: absolute;
    //   right: 0;
    // }
    &Title {
      font-family: Source Han Sans;
      font-size: 22px;
      font-weight: 500;
      line-height: 32px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      color: #242933;
      // margin: 20px 0 12px;
      margin: 268px 0 12px;
    }
    &Info {
      font-family: Source Han Sans;
      font-size: 12px;
      font-weight: normal;
      line-height: 22px;
      text-align: justify; /* 浏览器可能不支持 */
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-8 */
      color: #525966;
    }
  }
}
.bannerSwipe {
  margin-top: 40px;
  --van-swipe-indicator-active-background: #525966;
  --van-swipe-indicator-inactive-background: #dfe1e6;
  --van-swipe-indicator-size: 8px;
  :deep(.van-swipe__indicators) {
  position: relative;
  margin-top: 40px;
  justify-content: center;
}
}
.swipe {
  --van-swipe-indicator-active-background: #525966;
  --van-swipe-indicator-inactive-background: #dfe1e6;
  --van-swipe-indicator-size: 8px;
}
</style>
